// extracted by mini-css-extract-plugin
export default {"risk-quantification-container":"RiskQuantification_risk-quantification-container__NTvNl"};